import { render, staticRenderFns } from "./SapCreateModal.vue?vue&type=template&id=bf616b14&scoped=true"
import script from "./SapCreateModal.vue?vue&type=script&lang=js"
export * from "./SapCreateModal.vue?vue&type=script&lang=js"
import style0 from "./SapCreateModal.vue?vue&type=style&index=0&id=bf616b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf616b14",
  null
  
)

export default component.exports